import { render } from "./floatingBar.component.vue?vue&type=template&id=5870208a"
import script from "./floatingBar.component.vue?vue&type=script&lang=js"
export * from "./floatingBar.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/periple/floatingBar.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5870208a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5870208a', __exports__)) {
    console.log('reload')
    api.reload('5870208a', __exports__)
  }
  
  module.hot.accept("./floatingBar.component.vue?vue&type=template&id=5870208a", () => {
    console.log('re-render')
    api.rerender('5870208a', render)
  })

}


export default __exports__